import { IConnectRender } from "../../../../definitions/IConnectRender";

/** Opción de un botón fijo del footer (`RegistroFincaModalRender` los tiene
 *  todos en su propio template — acá solo se dice si se muestra y qué hace). */
export type RegistroFincaFooterOption = {
  onClick: () => void;
  /** Label del botón; si no viene, se deja el texto por defecto del template. */
  label?: string;
  disabled?: boolean;
};

/** Qué botones fijos del footer usa el paso actual — `null`/`undefined` =
 *  oculto. El modal posee los 2 botones (`volver`/`submit`) en su propio
 *  template y solo los muestra/oculta y cablea según esto. Antes había un
 *  tercero ("Omitir") — se sacó definitivamente: con el borrador en
 *  memoria (sin IndexedDB), el botón "×" de cerrar la barra superior ya
 *  hace exactamente lo mismo (pierde todo el progreso), quedaba redundante. */
export type RegistroFincaFooterOptions = {
  volver?: RegistroFincaFooterOption | null;
  submit?: RegistroFincaFooterOption | null;
};

/** Base de cada paso del wizard de registro de finca. Cada paso es un
 *  componente independiente (no conoce a los demás — el orquestador vive en
 *  `RegistroFincaModalRender`): solo declara su contenido (`renderBody`/
 *  `connectBody`/`disposeBody`), qué botones fijos usa en el footer
 *  (`getFooterOptions`) y, opcionalmente, un panel de indicaciones
 *  (`getInstructions`, toggle "?" de la barra superior). */
export abstract class BaseRegistroFincaPasoRender {
  constructor(protected readonly clienteId: string) {}

  abstract renderBody(): string;
  abstract connectBody(): void;
  disposeBody(): void {}

  abstract getFooterOptions(): RegistroFincaFooterOptions;

  /** Contenido del panel de indicaciones (toggle "?" en la barra superior
   *  del modal), o `null` si este paso no tiene — el botón de ayuda se oculta
   *  en ese caso. */
  getInstructions(): IConnectRender | null {
    return null;
  }
}
